<div id="menuIzq" style="position: fixed;" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y"
    [matMenuTriggerFor]="rightMenu">
    <mat-menu #rightMenu="matMenu">
        <ng-template matMenuContent let-item="item">

            <button mat-menu-item (click)="deleteArchivo()">
                <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
                {{ 'gestion.seguimiento.actas.eliminar' | translate }}
            </button>
        </ng-template>
    </mat-menu>
</div>

<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros [name]="'filtros.periodo' | translate" [array]="periodos" [typeFilter]="Filters.PERIOD"
    (eventClick)="changePeriods($event)" [click]="false" />
  <app-filters filtros [name]="'filtros.lider' | translate" [typeFilter]="Filters.SUCURSALES"
    (eventClick)="changeResponsibles($event)" [click]="false" [array]="viewResponsables"
    [consolidado]="viewAllresponsibles" />
  <app-filters filtros [name]="'filtros.res' | translate" [typeFilter]="Filters.SUCURSALES"
    (eventClick)="changeResponsiblesActivity($event)" [click]="false" [array]="viewResponsablesActivity"
    [consolidado]="viewAllresponsiblesActivity" />
  <div borrador [ngStyle]="{'color':'gray'}" (click)="borrarFiltro()" class="iconoMen"
    matTooltip="{{'tooltips.borrar-filtros'|translate}}">
    <img src="./../../../../assets/img/eraser.png">
  </div>

  <div class="contenido" contenido>
    <div class="w3-row menuTable">
      <div class="w3-row" style="margin-left: 5vh;">
        <mat-icon class="iconoMen" [matMenuTriggerFor]="menuTable">more_vert</mat-icon>
      </div>
      <mat-menu #menuTable="matMenu">
        <button mat-menu-item (click)="excelExport()">
          {{ 'acciones.exportarExcel' | translate}}
          <mat-icon>description</mat-icon>
        </button>
      </mat-menu>
    </div>
    <div class="w3-row tableContainer">
      @if (viewTablero) {
      <table class="w3-table">
        <thead>
          <tr class="w3-table-title">
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.planes' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.proyectos.selec-responsible' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.inicio' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.dias' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.fin' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.estatus' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.acumulado' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.planeado' | translate}}
            </th>
            <th class="w3-border-right-balance marginIzq encabezados anchosColC">
              {{'cues.planes-seguimiento.ejecutado' | translate}}
            </th>
            @for (adicional of aditionals; track $index) {
            <th class="encabezados 3-border-right-balance textoOverFlow"
              style="padding: 0vw 10px; cursor: pointer; line-height: 1.2;">
              <span>{{adicional.nombre}}</span>
            </th>
            }
          </tr>
        </thead>
        @for (p of dataOrdenado; track p.id) {
        <tbody>
          <tr class="w3-table-trtd">
            <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw;">
              @if (!p.visible) {
              <mat-icon class="iconoMen" (click)="p.visible = !p.visible">expand_more</mat-icon>
              }@else {
              <mat-icon class="iconoMen" (click)="p.visible = !p.visible">expand_less</mat-icon>
              }
              <span [matTooltip]="p.nombre">{{p.nombre}}</span>
            </td>
            <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw; padding-left: 1vw;">
              <span [matTooltip]="p.responsable?.role_name">{{p.responsable?.role_name}}</span>
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{p.inicio | date:'dd/MM/yyyy'}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{p.dias}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{p.fin | date:'dd/MM/yyyy'}}
            </td>
            <td class="borderAllLow alinLeft anchosCol">

            </td>
            <td class="borderAllLow alinLeft anchosCol">

            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{getGoal(p.goals)['planned']}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{getGoal(p.goals)['executed'] === null ? 0 : getGoal(p.goals)['executed']}}
            </td>
            @for (adicional of p.adicionales; track $index) {
            <td class="borderAllLow"> <br> </td>
            }
          </tr>
          @if (p.visible) {
          @for (a of p.activities; track a.id) {
          <tr class="w3-table-trtd">
            <td class="borderAllLow alinLeft anchosColC" style="padding-left: 2vw;">
              {{a.nombre}}
            </td>
            <td class="borderAllLow alinLeft anchosColC textoOverFlow" style="max-width: 30vw; padding-left: 1vw;">
              <span [matTooltip]="a.responsable?.roleName">{{a.responsable?.roleName}}</span>
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{a.inicio | date:'dd/MM/yyyy'}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{a.days}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{a.fin | date:'dd/MM/yyyy'}}
            </td>
            <td class="borderAllLow alinLeft anchosCol estatCol" [ngStyle]="{'color': getEstatus(a, 'c')}"
              style="padding-left: 1vw; font-weight: 600;">
              {{getEstatus(a)}}
            </td>
            <td class="borderAllLow alinCenter anchosCol estatCol" style="padding-left: 1vw;">
              {{getAcumulado(a)}}
            </td>
            <td class="borderAllLow alinCenter anchosColC">
              {{getGoal(a.goals)['planned']}}
            </td>
            <td class="borderAllLow alinCenter anchosColC" style="cursor: pointer;"
              (dblclick)="previewGoal(a.goals, a)">
              {{getGoal(a.goals)['executed'] === null ? '-' : getGoal(a.goals)['executed']}}
            </td>
            @for (adicional of p.adicionales; track $index) {
            @switch (adicional.tipo) {
            @case ('TEXT') {
            <td class="borderAllLow" style="cursor: pointer;" (dblclick)="editAditional(adicional, a)">
              {{writeAditional(adicional, a)}} </td>
            }
            @case ('FILE') {
            <td class="borderAllLow alinCenter amchosColC">
              @if (writeAditional(adicional, a) !== undefined) {
              <div class="iconoArch" style="cursor: pointer;" (contextmenu)="onContextMenu($event, adicional, a)">
                <mat-icon matTooltip="{{writeAditional(adicional, a)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}"
                  (dblclick)="openFile(writeAditional(adicional, a, true))">attach_file</mat-icon>
              </div>
              }@else {
              <div class="iconoArch" style="cursor: pointer;" (dblclick)="editAditional(adicional, a)">
                <mat-icon matTooltip="{{'gestion.seguimiento.proy-estra.tooltipAdj' | translate}}" class="iconoMen"
                  [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
              </div>
              }
            </td>
            }
            }
            }
          </tr>
          }
          }
        </tbody>
        }
      </table>
      }@else {
      <app-skeleton-table [columnas]="8" [filas]="15" />
      }
    </div>
  </div>

</app-esqueleto-tableros>